import { Container, styled } from '@mui/material';
import { COLOR_CHATHAMS_BLUE } from 'popTheme';
import SignInBg from './signin_background.svg';

export const ScrollableContainer = styled(Container)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'auto',
  component: 'main',
  backgroundImage: `url(${SignInBg})`,
  backgroundColor: COLOR_CHATHAMS_BLUE,
  backgroundSize: 'cover',
  width: '100%',
  maxWidth: '33.75rem',
  borderRadius: '0.75rem',
  p: '0rem',

  '@media (max-width: 600px) and (max-height: 800px)': {
    position: 'relative',
    height: '100vh',
  },
}));
